<div class="w-100 h-100">
    <div class="d-flex w-100 h-100 justify-content-center" *ngIf="loading()">
        <app-progress-spinner class="m-auto">
        </app-progress-spinner>
    </div>

    <div class="d-flex w-100 h-100 justify-content-center" *ngIf="!loading() && !connections().length">
        <app-emptysate class="m-auto">
        </app-emptysate>
    </div>

    <div class="p-4" *ngIf="!loading() && connections().length">
        <div class="input-group mb-2">
            <span class="input-group-text fa-solid fa-magnifying-glass" id="basic-addon1"></span>
            <input [(ngModel)]="searchBarContent" type="text" class="form-control"
                placeholder="Busque por id, número de telefone ou nome no WhatsApp">
        </div>

        <div style="background-color:#F5F5F5;" class="gap-2 d-flex flex-column rounded mb-2">
            <div class="p-4">
                <div class="d-flex align-items-center gap-2 mb-2">
                    <h6 class="mb-0">Informações atualizadas em: {{lastUpdate()}}</h6>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="loadConnections()" [disabled]="refreshing()">
                        <i class="fa-solid fa-arrows-rotate"></i>
                        {{ refreshing() ? 'Atualizando...' : 'Atualizar' }}
                    </button>
                </div>
                <div>
                    <h6>
                        <span role="button" data-bs-toggle="collapse" data-bs-target="#minhaDiv" aria-expanded="false"
                            aria-controls="minhaDiv">
                            Filtros
                            <i class="fa-solid fa-arrow-down"></i>
                        </span>
                    </h6>

                    <div class="collapse" id="minhaDiv">
                        <div class="card card-body mt-2">
                            <div class="d-flex gap-4">
                                <h6>Status da conexão</h6>
                                <div id="statusFilter">
                                    <div *ngFor="let filter of connectionStatusFilters" class="form-check">
                                        <input class="form-check-input" [(ngModel)]="filter.checked"
                                            [checked]="filter.checked" type="checkbox" id="{{filter.label}}">
                                        <label class="form-check-label" for="{{filter.label}}">
                                            {{filter.label}}
                                        </label>
                                    </div>
                                </div>
                                <h6>Contexto</h6>
                                <div id="tenantFilter">
                                    <div *ngFor="let filter of connectionTenantFilters" class="form-check">
                                        <input class="form-check-input" [(ngModel)]="filter.checked"
                                            [checked]="filter.checked" type="checkbox" id="{{filter.value.name}}">
                                        <label class="form-check-label" for="{{filter.value.name}}">
                                            {{filter.value.label}}
                                        </label>
                                    </div>
                                </div>
                                <h6>Infraestrutura</h6>
                                <div id="infrastructureFilter">
                                    <div *ngFor="let filter of connectionInfraFilters" class="form-check">
                                        <input class="form-check-input" [(ngModel)]="filter.checked"
                                            [checked]="filter.checked" type="checkbox" id="{{filter.value}}">
                                        <label class="form-check-label" for="{{filter.value}}">
                                            {{filter.label}}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="main-container px-4" *ngIf="!loading() && connections().length">
        <div *ngFor="let connection of (connections() | searchConnection:searchBarContent |
                                                    status:connectionStatusFilters |
                                                    tenant:connectionTenantFilters |
                                                    infra:connectionInfraFilters)"
            class="card d-inline-flex mb-1 me-1 connection">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center">
                    <h5 class="card-title text-truncate mb-2">{{connection.connection?.pushName ||
                        connection.connectionId}}</h5>
                    <div class="d-flex align-items-center gap-2 ">
                        <i matTooltip="Conexão não está presente no banco de dados" *ngIf="!connection?.connection"
                            class="text-warning fa-solid fa-database"></i>

                        <i matTooltip="Conexão não possui infraestrutura criada" *ngIf="!connection?.pod"
                            class="text-warning fa-solid fa-triangle-exclamation"></i>
                        <div class="dropdown">
                            <button class="icon-button" type="button"
                                id="dropdownMenuButton-{{connection.connectionId}}" data-bs-toggle="dropdown"
                                aria-expanded="false">
                                <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul class="dropdown-menu"
                                attr.aria-labelledby="dropdownMenuButton-{{connection.connectionId}}">
                                <li class="d-flex align-items-center gap-2">
                                    <button (click)="openLogs(connection)" class="dropdown-item">
                                        <i class="fa fa-history" aria-hidden="true"></i>
                                        Abrir logs
                                    </button>
                                </li>
                                <li class="d-flex align-items-center gap-2">
                                    <button (click)="openScreenshot(connection)" class="dropdown-item"
                                        [disabled]="!canTakeScreenshot()"
                                        [matTooltip]="canTakeScreenshot() ? '' : 'Apenas alvaro.moura@nibo.com.br pode tirar screenshot'">
                                        <i class="fa-solid fa-image" aria-hidden="true"></i>
                                        Ver screenshot
                                    </button>
                                </li>
                                <li class="d-flex align-items-center gap-2">
                                    <a class="dropdown-item" [routerLink]="['/whatsapp', 'connections', connection.connectionId, 'update']">
                                        <i class="fa-solid fa-gear"></i>
                                        Atualizar conexão
                                    </a>
                                </li>
                                <li class="d-flex align-items-center gap-2">
                                    <button (click)="openConfirmRestart(connection)" class="dropdown-item">
                                        <i class="fa-solid fa-power-off"></i>
                                        Reiniciar conexão
                                    </button>
                                </li>
                                <li class="d-flex align-items-center gap-2">
                                    <button (click)="openConfirmRecreate(connection)" class="dropdown-item">
                                        <i class="fa-solid fa-recycle"></i>
                                        Recriar conexão
                                    </button>
                                </li>
                                <li class="d-flex align-items-center gap-2">
                                    <button (click)="openConfirmDelete(connection)" class="dropdown-item">
                                        <i class="fa-solid fa-trash"></i>
                                        Deletar conexão
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="d-flex gap-2 align-items-center">
                        <p>Status: </p>
                        <span *ngIf="connection.connection?.whatsAppStatus === 0"
                            class="badge bg-secondary">Indefinido</span>
                        <span *ngIf="connection.connection?.whatsAppStatus === 1" class="badge bg-success">Online</span>
                        <span *ngIf="connection.connection?.whatsAppStatus === 2" class="badge bg-info">QR
                            Code</span>
                        <span *ngIf="connection.connection?.whatsAppStatus === 3"
                            class="badge bg-warning">Inicializando</span>
                        <span *ngIf="connection.connection?.whatsAppStatus === 4" class="badge bg-success">Online</span>
                        <span *ngIf="connection.connection?.whatsAppStatus === 5" class="badge bg-danger">Offline</span>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <p>Contexto: </p>
                        <span>{{connection?.tenant?.label}}</span>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <p>Criada em: </p>
                        <span>{{connection?.connection?.createdAt | date:'medium'}}</span>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <p>Telefone: </p>
                        <span>{{connection?.connection?.phoneNumber}}</span>
                    </div>
                    <div class="d-flex gap-2 align-items-center">
                        <p>Id: </p>
                        <span (click)="copyConnectionId(connection.connectionId)" matTooltipPosition="after"
                            matTooltip="Copiar" id="connectionId" role="button"
                            class="text-truncate">{{connection?.connectionId}}</span>
                    </div>
                    <div class="mt-1">
                        <h6>
                            <span role="button" data-bs-toggle="collapse"
                                attr.data-bs-target="#l{{connection.connectionId}}" aria-expanded="false"
                                attr.aria-controls="{{connection.connectionId}}">
                                Rótulos
                                <i class="fa-solid fa-arrow-down"></i>
                            </span>
                        </h6>
                        <div class="collapse" id="l{{connection.connectionId}}">
                            <div *ngIf="!connection.labels">
                                Não há rótulos para esta conexão
                            </div>
                            <ul *ngIf="connection.labels" class="list-group">
                                <li *ngFor="let label of connection.labels | keyvalue" class="list-group-item">
                                    {{label.key}}: {{label.value}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>